'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('components/Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _LogoShape = require('components/LogoShape/LogoShape');

var _LogoShape2 = _interopRequireDefault(_LogoShape);

var _PageLink = require('containers/PageLink');

var _PageLink2 = _interopRequireDefault(_PageLink);

var _home = require('./home.css');

var _home2 = _interopRequireDefault(_home);

var _homeNav = require('./homeNav.css');

var _homeNav2 = _interopRequireDefault(_homeNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Home = function (_Component) {
  _inherits(Home, _Component);

  function Home() {
    _classCallCheck(this, Home);

    var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this));

    _this.state = {
      isPlaying: false,
      currentIndex: 0,
      w: 0
    };
    return _this;
  }

  _createClass(Home, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var cmsRequested = this.props.cmsRequested;


      this.setState({ w: window.innerWidth });

      this.resizeHandler = this.resize.bind(this);

      window.addEventListener('resize', this.resizeHandler);

      cmsRequested();
      this.checkUrl();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }, {
    key: 'resize',
    value: function resize() {
      this.setState({
        w: window.innerWidth
      });
    }
  }, {
    key: 'checkUrl',
    value: function checkUrl() {
      var pathname = this.props.location.pathname;

      if (pathname === 'showreel') {
        this.setState({
          isPlaying: true
        });
        this.refs.reel.play();
      } else {
        this.setState({
          isPlaying: false
        });
        this.refs.reel.pause();
        this.refs.reel.currentTime = 0;
      }
    }
  }, {
    key: 'toggleShowreel',
    value: function toggleShowreel() {
      var isPlaying = this.state.isPlaying;


      if (isPlaying) {
        this.setState({ isPlaying: false });
        this.refs.reel.pause();
        this.refs.reel.currentTime = 0;
      } else {
        this.setState({ isPlaying: true });
        this.refs.reel.play();
      }
    }
  }, {
    key: 'renderImages',
    value: function renderImages() {
      var _this2 = this;

      var images = ['/images/splash/1.jpg', '/images/splash/2.jpg', '/images/splash/3.jpg', '/images/splash/4.jpg', '/images/splash/5.jpg'];
      var limit = images.length - 1;
      var currentIndex = this.state.currentIndex;
      var duration = 4000;

      setTimeout(function () {
        if (currentIndex === limit) {
          currentIndex = 0;
          _this2.setState({ currentIndex: currentIndex });
        } else {
          currentIndex++;
          _this2.setState({ currentIndex: currentIndex });
        }
      }, duration);

      return _react2.default.createElement(
        'div',
        { className: _home2.default.mobileCarousel },
        images.map(function (item, index) {
          var itemClass = index === currentIndex ? _home2.default.mobileItemActive : _home2.default.mobileItem;

          return _react2.default.createElement('div', { className: itemClass, key: index, style: { backgroundImage: 'url(' + images[index] + ')' } });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          isPlaying = _state.isPlaying,
          w = _state.w;

      var homeClass = isPlaying ? _home2.default.homePlaying : _home2.default.home;
      var holderClass = isPlaying ? _homeNav2.default.holderHidden : _homeNav2.default.holder;
      var overlayClass = isPlaying ? _home2.default.overlayHidden : _home2.default.overlay;
      var reelClass = isPlaying ? _home2.default.reel : _home2.default.reelHidden;

      return _react2.default.createElement(
        'div',
        { className: homeClass },
        _react2.default.createElement(
          'div',
          { className: holderClass },
          _react2.default.createElement(
            _PageLink2.default,
            {
              to: '/creative',
              className: _homeNav2.default.item
            },
            _react2.default.createElement(
              'h3',
              { className: _homeNav2.default.title },
              'creative.'
            ),
            _react2.default.createElement(
              'p',
              { className: _homeNav2.default.strap },
              'We leverage sound as a tool to enhance brand identity, experience and value. Artistically unique, commercially driven.'
            ),
            _react2.default.createElement('span', { className: _homeNav2.default.line }),
            _react2.default.createElement(
              'span',
              { className: _homeNav2.default.findMore },
              'Find out more'
            )
          ),
          _react2.default.createElement(
            _PageLink2.default,
            {
              to: '/technical',
              className: _homeNav2.default.item
            },
            _react2.default.createElement(
              'h3',
              { className: _homeNav2.default.title },
              'technical.'
            ),
            _react2.default.createElement(
              'p',
              { className: _homeNav2.default.strap },
              'AV & IT solutions that are simple, beautiful and future-ready. Engineered in London, installed globally.'
            ),
            _react2.default.createElement('span', { className: _homeNav2.default.line }),
            _react2.default.createElement(
              'span',
              { className: _homeNav2.default.findMore },
              'Find out more'
            )
          )
        ),
        _react2.default.createElement(_LogoShape2.default, { isMoving: true, isHome: true, css: { opacity: isPlaying ? 0 : 1 } }),
        _react2.default.createElement('div', { className: overlayClass }),
        this.renderImages(),
        _react2.default.createElement(
          'video',
          { className: _home2.default.video, loop: true, muted: true, autoPlay: true },
          _react2.default.createElement('source', { src: 'videos/video2.mp4', type: 'video/mp4' })
        ),
        _react2.default.createElement(
          'video',
          { className: reelClass, loop: true, controls: w <= 800 || false, ref: 'reel' },
          _react2.default.createElement('source', { src: 'videos/reel.mp4', type: 'video/mp4' })
        ),
        _react2.default.createElement(
          'div',
          { className: _home2.default.watch },
          _react2.default.createElement(
            'div',
            { className: _home2.default.watchButton, onClick: this.toggleShowreel.bind(this) },
            _react2.default.createElement(
              'div',
              { className: isPlaying ? _home2.default.watchIconPlaying : _home2.default.watchIcon },
              _react2.default.createElement(_Icon2.default, { type: 'pl', width: 10, height: 14 })
            ),
            isPlaying ? 'Back home' : 'Watch showreel'
          )
        )
      );
    }
  }]);

  return Home;
}(_react.Component);

exports.default = Home;


Home.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Home.js
// module id = 324
// module chunks = 1